import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { DatePipe } from '@angular/common';
import { PanelList } from '../../shared/models/panel-list';
import { SortMenu } from '../../shared/models/sort-menu';
import { FilterMenu } from '../../shared/models/filter-menu';
import { CommonService } from '../../shared/services/common.service';
import { ActionItemSearchResult } from '../models/action-item-search-result';
import { EqmsScopeManagementService } from '../../shared/services/eqms-scope-management.service';

@Component({
  selector: 'app-action-item-panel-list',
  templateUrl: './action-item-panel-list.component.html',
  styleUrls: ['./action-item-panel-list.component.scss']
})
export class ActionItemPanelListComponent implements OnInit, OnChanges {
  @Input() actionItemSearchResult: ActionItemSearchResult[] | undefined = undefined;
  @Output() selectedItems = new EventEmitter();
  @Input() enableCheckBoxes : boolean = false;
  noData: boolean = false;
  isPanelListDataAvailable = false;
  initialized: boolean = false;

  actionItemPanelListData: PanelList = {
    title: undefined,
    lists: [],
    enableFilter: true,
    enableSort: true,
    filters: [],
    sort: [],
    enableSelection: false,
    enableToggling: true,
  };

  constructor(private commonService: CommonService, private eqmsScopeManagementService: EqmsScopeManagementService, private datePipe: DatePipe) { }

  ngOnInit(): void {
    this.setPanelList();
    this.initialized = true;
  }

  ngOnChanges() {
    if(!this.initialized) { return;}
    this.setPanelList();
  }

  setPanelList() {
    this.actionItemPanelListData.lists = this.actionItemSearchResult;
    this.noData = this.commonService.IsListEmpty(this.actionItemSearchResult);
    this.updateeQMSScopeData();
  }

  updateeQMSScopeData(){
    this.eqmsScopeManagementService.geteQMSScopeLookup().subscribe((eQMSScopes)=>{
      this.actionItemPanelListData.lists.forEach((actionItemDetail: {
        eQMSScopeDisplayNames: string[]; eQMSScope: number[]; 
        })=>{
          actionItemDetail.eQMSScopeDisplayNames = [];
          actionItemDetail.eQMSScope.forEach((eQMSScopeData : number)=>{
          let eQMSScope = eQMSScopes.filter((e: { eQMSScopeId: number; }) => {return e.eQMSScopeId === eQMSScopeData});
          if(actionItemDetail.eQMSScopeDisplayNames === undefined || actionItemDetail.eQMSScopeDisplayNames === null) 
            actionItemDetail.eQMSScopeDisplayNames = [];
          actionItemDetail.eQMSScopeDisplayNames?.push(eQMSScope[0].eQMSScopeName);
        })
      })
      this.actionItemPanelListData.filters = this.getFiltersForActionItemPanelList();
      this.actionItemPanelListData.sort = this.getSortFieldsForActionItemPanelList();
      this.actionItemPanelListData = { ...this.actionItemPanelListData }
      this.actionItemPanelListData.enableSelection = this.enableCheckBoxes;
      this.isPanelListDataAvailable = true;
    });
  }

  clearSelection(){
    this.actionItemPanelListData.clearSelection = true;
    this.actionItemPanelListData = { ...this.actionItemPanelListData }
  }

  // To get Filter Options
  getFiltersForActionItemPanelList = (): FilterMenu[] => {
    let filters: FilterMenu[] = [];
    filters.push(
      {
        filterDisplayName: 'Status',
        filterFieldName: 'statusName',
      },
      {
        filterDisplayName: 'Assigned User',
        filterFieldName: 'assignedUser',
      },
      {
        filterDisplayName: 'Verifier',
        filterFieldName: 'verifier',
      },
      {
        filterDisplayName: 'Type',
        filterFieldName: 'typeName',
      }
    );
    return filters;
  };

  // To get Sort Options
  getSortFieldsForActionItemPanelList = (): SortMenu[] => {
    let sortMenu: SortMenu[] = [];
    sortMenu.push(
      {
        sortFieldDisplayName: 'Status',
        sortFieldName: 'statusName',
      },
      {
        sortFieldDisplayName: 'Assigned User',
        sortFieldName: 'assignedUser',
      },
      {
        sortFieldDisplayName: 'Verifier',
        sortFieldName: 'verifier',
      },
      {
        sortFieldDisplayName: 'Type',
        sortFieldName: 'typeName'
      },
      {
        sortFieldDisplayName: 'Due Date',
        sortFieldName: 'dueDate'
      }
    );
    return sortMenu;
  };

  openChangeControl(changeControlNumber: string) {
    var url = location.origin.concat("/eqms.changeControlDetails/", changeControlNumber);
    window.open(url, "_blank");
  }

  calculateStatusColor = (status: string): string => {
    let statusColor = '';
    switch (status) {
      case '0':
        statusColor = 'in_Scheduled';
        break;
      case '1':
        statusColor = 'in_Pending';
        break;
      case '2':
        statusColor = 'in_ReadyforVerification';
        break;
      case '3':
        statusColor = 'in_Complete';
        break;
      case '4':
        statusColor = 'in_Voided';
        break;
      case '5':
        statusColor = 'in_Deferred';
        break;     
    }
    return statusColor;
  };

  getSelectedItems(selectedItemsData: ActionItemSearchResult[]) {
    this.selectedItems.emit(selectedItemsData);
  }

  displayStatusLabelWithDate = (status: string, completionDate: Date, dueDate: Date, statusName: string): string => {
    let displayData = '';
    switch (status) {
      case '0':
        displayData = dueDate != null ? statusName + ' (' + this.datePipe.transform(dueDate, "dd-MMM-yyyy") +')': statusName;
        break;
      case '1':
        displayData = dueDate != null ? statusName + ' (' + this.datePipe.transform(dueDate, "dd-MMM-yyyy") +')': statusName;
        break;
      case '2':
        displayData = dueDate != null ? statusName + ' ('+  this.datePipe.transform(dueDate, "dd-MMM-yyyy") +')': statusName;
        break;
      case '3':
        displayData = completionDate != null ? statusName + ' (' + this.datePipe.transform(completionDate, "dd-MMM-yyyy") + ')': statusName;
        break;
      case '4':
        displayData = dueDate != null ? statusName + ' ('  + this.datePipe.transform(dueDate, "dd-MMM-yyyy")+ ')' : statusName;
        break;
      case '5':
        displayData = dueDate != null ? statusName + ' (' + this.datePipe.transform(dueDate, "dd-MMM-yyyy") + ')': statusName;
        break;
    }
    return displayData;
  };
}
